import { render } from "./ExclusionAreaSidebar.vue?vue&type=template&id=e8308ce8&scoped=true"
import script from "./ExclusionAreaSidebar.vue?vue&type=script&lang=js"
export * from "./ExclusionAreaSidebar.vue?vue&type=script&lang=js"

import "./ExclusionAreaSidebar.vue?vue&type=style&index=0&id=e8308ce8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8308ce8"]])

export default __exports__